import { ScreenSharingStatus } from '@agent/agent-interface/contact-view/chat/model/screen-sharing-info';
import { ChatEmojiService } from '@agent/agent-interface/contact-view/chat/services/chat-emoji.service';
import { ChatTimerService } from '@agent/agent-interface/contact-view/chat/services/chat-timer.service';
import { DisplayModeService } from '@agent/core/settings/display-mode.service';
import { Component, OnDestroy, OnInit } from '@angular/core';

import { fTruthy, LayoutFacade, UntilDestroy, untilDestroyed } from '@contact/upgrade';

import { ChatModel } from '../../model/chat-model';
import { ChatSocketService } from '../../services/chat-socket.service';

@UntilDestroy()
@Component({
  selector: 'chat-banner',
  templateUrl: 'chat-banner.component.html',
  styleUrls: ['./chat-banner.component.scss'],
})
export class ChatBannerComponent implements OnInit, OnDestroy {
  showBanner: boolean = true;
  time: string;
  chatOnHover: ChatModel;
  public showAgentMenu: boolean;

  constructor(
    private readonly chatSocketService: ChatSocketService,
    private readonly emojiService: ChatEmojiService,
    private readonly chatTimerService: ChatTimerService,
    private readonly layoutFacade: LayoutFacade,
    private readonly displayModeService: DisplayModeService
  ) {}

  ngOnInit() {
    this.displayModeService.toggleChatBanner(this.showBanner);
    this.displayModeService.helpzone$.pipe(untilDestroyed(this), fTruthy()).subscribe(_ => {
      this.showBanner = false;
      this.displayModeService.toggleChatBanner(false);
    });
    this.layoutFacade.menu$.pipe(untilDestroyed(this)).subscribe(showMenu => (this.showAgentMenu = showMenu));
  }

  ngOnDestroy() {
    this.displayModeService.toggleChatBanner(false);
  }

  moveBanner(): void {
    const state = !this.showBanner;

    this.showBanner = state;
    this.displayModeService.toggleChatBanner(state);
  }

  public isSelected(chat: ChatModel): boolean {
    return this.chatSocketService.activeChat === chat;
  }

  selectChat(selectedChat: ChatModel): void {
    this.chatSocketService.selectChat(selectedChat);
  }

  isSelectedSlaExceeded(chat: ChatModel): boolean {
    let isSelectedSlaExceeded = false;
    if (chat.durationExceeded()) {
      isSelectedSlaExceeded = true;
    }
    return isSelectedSlaExceeded;
  }

  getSlaTimer(chat: ChatModel): number {
    return this.chatTimerService.getSlaTimerValue(chat) * 1000;
  }

  getTimeBeforeDurationCountdown(chat: ChatModel): number {
    return this.chatTimerService.getDurationExceededCountdownTimer(chat) * 1000;
  }

  getTimerForLastMessageValue(chat: ChatModel): number {
    return this.chatTimerService.getTimerForLastMessageValue(chat) * 1000;
  }

  getPostTreatmentTimerValue(chat: ChatModel): number {
    return this.chatTimerService.getPostTreatmentTimerValue(chat) * 1000;
  }

  getPostTreatmentExceededTimerValue(chat: ChatModel): number {
    return this.chatTimerService.getPostTreatmentTimerReprieveValue(chat) * 1000;
  }

  postTreatmentDurationExceeded(chat: ChatModel) {
    let isPostTreatmentExceededMode = this.chatTimerService.getPostTreatmentTimerValue(chat) <= 0;
    if (isPostTreatmentExceededMode && !chat.inPostTreatmentExceededMode) {
      chat.inPostTreatmentExceededMode = true;
      this.chatSocketService.updateChatHavePostTreatmentDurationExceeded();
    }
    return isPostTreatmentExceededMode;
  }
  getMessageContent(message: string): string {
    let text = message.replace(/(<\/?(?:p|img)[^>]*>)|<[^>]+>/gi, '');

    return this.emojiService.emojify(text);
  }
  getMessageContentWithUrl(message: string): string {
    return this.emojiService.emojify(message);
  }

  public screenSharingActivated(chat: ChatModel): boolean {
    return chat.screenSharingInfos && chat.screenSharingInfos.status === ScreenSharingStatus.ONGOING;
  }
}
